export const questionsList = '/questions';
export const content = '/content';
export const results = '/results';
export const generateResult = '/results/generate';
export const emailResult = '/results/email-result';
